<script>
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import Heading from "$lib/components/Heading.svelte";
  import SocialBar from "$lib/islands/Components/SocialBar.svelte";
  import Island from "./Island.svelte";

  export let subtitle = "";
  export let title = "";
  export let logo;
  export let shareText = "";
</script>

<div class="flex flex-col justify-center items-center">
  <div class="order-2 text-center" class:pt-20={!!logo} class:lg:pt-48={!!logo}>
    <div class="flex flex-col">
      {#if title}
        <Heading text={title} class="order-2 font-gotham font-bold text-size-18 lg:text-size-40" />
      {/if}

      {#if subtitle}
        <p class="order-1 font-heading text-size-14 lg:text-size-24">{subtitle}</p>
      {/if}
    </div>
  </div>

  {#if logo}
    <div class="order-1">
      <ImageComponent
        data={logo}
        elementClass="h-78 lg:h-132 w-auto"
        lg="132px"
        md="78px"
        sm="78px"
      />
    </div>
  {/if}

  <Island
    component={SocialBar}
    name="SocialBar"
    islandProps={{ class: "order-3" }}
    class={subtitle || title || logo ? "pt-16 lg:pt-32" : ""}
    iconSpacingClass="gap-32 lg:gap-48"
    shareButtonsLabel=""
    {shareText}
  />
</div>
